// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoBg_wrapper__FXYCJ","video":"VideoBg_video__c48pB","overlay":"VideoBg_overlay__wcMyS"};